import { Button, IconButton } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import FormulaBuilder from 'components/FormulaBuilder/FormulaBuilder';
import StatColumn from 'components/StatColumn/StatColumn';
import { StatContext } from 'context/StatContext';
import { useContext } from 'react';
import './StatBlock.scoped.scss';

export default function StatBlock() {
    const context = useContext(StatContext);
    let i = 0;

    return (
        <div className="flex-col container">
            <div className="title-bar">
                <h2>Stat Block</h2>
            </div>
            <div className="actions">
                <Button color="secondary" onClick={context.addStat}>+ Stat</Button>
            </div>
            <StatContext.Consumer>
                {_ => <FormulaBuilder />}
            </StatContext.Consumer>
            <div className="columns flex-row">
                {context.stats.map(stat =>
                    <div className="fade-in-column" key={i++}>
                        <StatColumn
                            stat={stat} />
                    </div>)}
                <div className="card flex-col">
                    <Button color="secondary" className="button-card" onClick={context.addStat} />
                    <h3>Add a new stat</h3>
                    <IconButton color="secondary">
                        <Add fontSize="large"></Add>
                    </IconButton>
                </div>
            </div>
        </div>
    )
}